module.exports = __webpack_public_path__ + "media/images/placeholder-platform-announcement-e7f409e6.png";